import React from "react";
import Skeletons from "./Skeletons";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { View } from "react-native";

const GameShowCardSkeleton = () => {
  const deviceSize = useDeviceSize();
  const isMobile =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;

  return (
    <View
      style={{
        padding: isMobile ? 12 : 20,
      }}
    >
      <Skeletons
        height={isMobile ? 160 : 220}
        width="100%"
        style={{
          borderRadius: 0,
        }}
      />
    </View>
  );
};

export default GameShowCardSkeleton;
